import type { StateCreator } from 'zustand'
import type { AppStore } from '../useStore'

const STORAGE_KEY = 'mmm-v3:ui'

export type RouteState = Record<string, unknown>

export interface UiSlice {
  routes: Record<string, RouteState>
  setRouteState: (routeId: string, partial: RouteState) => void
  getRouteState: (routeId: string) => RouteState
  clearAll: () => void
}

function load(): Record<string, RouteState> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as Record<string, RouteState>) : {}
  } catch {
    return {}
  }
}

function save(routes: Record<string, RouteState>) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(routes))
}

export const createUiSlice: StateCreator<AppStore, [], [], { ui: UiSlice }> = (set, get) => ({
  ui: {
    routes: load(),
    setRouteState: (routeId, partial) => {
      const next = {
        ...get().ui.routes,
        [routeId]: { ...(get().ui.routes[routeId] ?? {}), ...partial },
      }
      set((s) => ({ ui: { ...s.ui, routes: next } }))
      save(next)
    },
    getRouteState: (routeId) => get().ui.routes[routeId] ?? {},
    clearAll: () => {
      localStorage.removeItem(STORAGE_KEY)
      set((s) => ({ ui: { ...s.ui, routes: {} } }))
    },
  },
})
